import type { IconSvgObject } from './types';

const OnlineLearning02Icon: IconSvgObject = [
  ["path", { d: "M20 22H6C4.89543 22 4 21.1046 4 20M4 20C4 18.8954 4.89543 18 6 18H20V2H6C4.89543 2 4 2.89543 4 4V20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 18C19.5 18 18.5 18.7628 18.5 20C18.5 21.2372 19.5 22 19.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 8.44561C8 8.44561 9.5 7.00004 12.0045 7C14.5091 6.99996 16 8.44561 16 8.44561M14.5 11C14.5 11 13.5091 9.99742 12.0045 9.99742C10.5 9.99742 9.5 11 9.5 11M12 13H12.01", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default OnlineLearning02Icon;
